export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_05.defbbb97.jpg";